export const normalizeName = (name?: string): string => {
  if (!name || name.length <= 2) return name || '';
  return `${name?.substring(0, 1).toUpperCase() + name?.substring(1).toLowerCase()}`;
};
